import { createContext } from "react"

// Shared context used by both legacy and V2 MarinaSchedule views
// The context values differ slightly between versions, but the core values
// (currentAppointment, marinaTimezone, trackingProps, etc.) are shared
export const MarinaScheduleContext = createContext(null)
